// 人脸认证路由配置
const realNameAuthenticationRouter = [
  {
    path: "/realNameAuthentication",
    name: "index",
    component: () => import("@/pages/realNameAuthentication/index.vue")
  },
   {
    path: "/identityInformation",
    name: "IdentityInformation",
    component: () => import("@/pages/realNameAuthentication/components/IdentityInformation.vue")
  },
   {
    path: "/uploadIDCard",
    name: "UploadIDCard",
    component: () => import("@/pages/realNameAuthentication/components/UploadIDCard.vue")
  },
   {
    path: "/informationVerification",
    name: "InformationVerification",
    component: () => import("@/pages/realNameAuthentication/components/InformationVerification.vue")
  },
   {
    path: "/photograph",
    name: "Photograph",
    component: () => import("@/pages/realNameAuthentication/components/Photograph.vue")
  },
   {
    path: "/videoRecording",
    name: "VideoRecording",
    component: () => import("@/pages/realNameAuthentication/components/VideoRecording.vue")
  },
   {
    path: "/realNameAuthResult",
    name: "RealNameAuthResult",
    component: () => import("@/pages/realNameAuthentication/components/RealNameAuthResult.vue")
  },
];
export default realNameAuthenticationRouter;



// WEBPACK FOOTER //
// ./src/router/modules/realNameAuthentication.js